export function trackGoal (goalName) {
    const LANG = App.page.lang
    let goalId = LANG === 'ru' ? 45303309 : 45303330
    ym(goalId, 'reachGoal', goalName)
}
